// @flow

import * as React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import I18nContext from './i18n-context';

function get(locale, str) {
  return locale[str] || str;
}

export default function decorate(WrappedComponent: React.ComponentType<{}>) {
  class Enhanced extends React.Component {
    static contextType = I18nContext;

    translate = (str, ...args) => {
      const locale = (this.context && this.context.locale) || {};
      const localized = get(locale, str);

      if (args.length) {
        return localized
          .replace(/%([0-9]+)\$[sd]/g, (m, n) => args[n - 1])
          .replace(/%[sd]/g, () => args.shift());
      }

      return localized;
    };

    render() {
      return <WrappedComponent {...this.props} i18n={this.translate} />;
    }
  }

  hoistNonReactStatics(Enhanced, WrappedComponent);

  return Enhanced;
}